import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

const currentUserQuery = gql`
  query dismissibleJobsCtaCurrentUser {
    currentUser: currentUserV2 {
      hasSeenNotifications {
        jobsCta
      }
      id
      isLoggedIn
    }
  }
`;

const accountQuery = gql`
  query dismissibleJobsCtaAccount($accountId: Int!) {
    account(id: $accountId) {
      id
      isCompanyAccount
    }
  }
`;

export type Props = {
  skip?: boolean;
};

export const useShouldRender = ({ skip }: Props = {}) => {
  const { data: currentUserData } = useQuery(currentUserQuery, {
    skip,
  });

  const accountId = parseInt(localStorage.getItem('currentAccountId') ?? '');

  const {
    data: accountData,
    error: accountError,
    loading: isLoadingAccount,
  } = useQuery(accountQuery, {
    skip: skip || !currentUserData?.isLoggedIn || !accountId,
    variables: {
      accountId,
    },
  });

  return isLoadingAccount || accountError
    ? false
    : !currentUserData?.currentUser?.hasSeenNotifications?.jobsCta &&
        !accountData?.account?.isCompanyAccount;
};
